/* eslint-disable jira/filename-case */
type Callback<T = unknown> = (payload: T) => void;

/**
 * simple event bus
 */
export const createEventBus = (): {
	subscribe: <T = unknown>(event: string, listener: Callback<T>) => () => void;
	emit: (event: string, payload: unknown) => void;
	readonly length: number;
} => {
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	const listeners = new Map<Callback<any>, string>();

	const subscribe = <T = unknown,>(event: string, listener: Callback<T>) => {
		listeners.set(listener, event);
		return (): void => {
			listeners.delete(listener);
		};
	};
	const emit = (event: string, payload: unknown): void => {
		listeners.forEach((eventFilter, listener) => {
			if (eventFilter === event) {
				listener(payload);
			}
		});
	};

	return {
		subscribe,
		emit,
		get length(): number {
			return listeners.size;
		},
	};
};
